import React from 'react';
import Navbar from '../components/Navbar';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "Facter",
      description: "Facter was born from the need to simplify the process of verifying information encountered online. In an age where misinformation spreads quickly, students and researchers are often left spending excessive time manually cross-checking claims against credible sources. This not only interrupts their workflow but can also make rigorous verification feel tedious. Facter solves this by combining customizable search capabilities with AI-powered analysis, enabling users to highlight or paste a statement and instantly see a verdict supported by relevant references. And surprisingly, there are no similar products on the market!",
      link: "https://github.com/RoyArkh/Facter",
      color: "bg-green-300"
    },
    {
      id: 2,
      title: "Youga (Coming Soon)",
      description: "In collaboration with my friend Kerem we are making an app that will help people to have a more healthy lifestile. Youga is centered around YOU! The app will have journalling, habit tracking, live guided yoga sessions catered for you, and much more. Currently in development, stay tuned to be first to know when it comes out!",
      link: "http://localhost:3000/projects",
      color: "bg-purple-200"
    },
    {
      id: 3,
      title: "AgroPoint",
      description: "AgroPoint got the most innovative project nomination! Initially started as part of the Vodafone Campus Lab competition AgroPoint is an app which will make it easier for consumers to support smallholder farmers while purchasing high quality agricultural products. The platform is aimed at unifying the rural communities through an easier access to market. In many cities across the world supermarkets became the standard which damages the income of the small-scale farmers due to the current market structure. We want to persuade all small-scale farmers along with the consumers to be more proactive and support each other. Our easy-to-use app encourages more people to start farming, helping minority groups and novices, which will make our world a more sustainable place.",
      link: "https://github.com/RoyArkh/AgroPointV2",
      color: "bg-green-200"
    },
    {
      id: 4,
      title: "BetBlitz",
      description: "While it might sound shady, betblitz is actually a fake sports betting website. The first project where I made a proper database configuration. Optimized by me using SQL it has a lot of beautiful database designs and configurations. Although simple, it started my obsession with DBMS tools and now I know how to use most of those.",
      link: "https://github.com/RoyArkh/databases_project",
      color: "bg-orange-200"
    },
    {
      id: 5,
      title: "Turkify",
      description: "Initially started as a project for TEKNOFEST competition to empower expatriates, and foreigners in Turkey by providing an accessible, interactive platform for learning Turkish, fostering language proficiency and cultural integration through personalized, real-time practice and engaging offline resources. We aim to bridge language barriers and facilitate smoother societal integration, contributing to both individual growth and community cohesion. ",
      link: "https://sites.google.com/view/turkify",
      color: "bg-red-200"
    },
    {
      id: 6,
      title: "Gladder (Coming Soon)",
      description: "Gladder is a personal project of mine that is going to emprower women. Not yet in development, stay tuned.",
      link: "http://localhost:3000/projects",
      color: "bg-cyan-200"
    }
  ];

  return (
    <div className="min-h-screen bg-black">
      {/* Mobile Navbar */}
      <div className="md:hidden">
        <Navbar dark={true} mobile={true} />
      </div>
      
      {/* Desktop Navbar */}
      <div className="hidden md:block">
        <Navbar dark={true} />
      </div>
      
      <div className="container mx-auto px-6 md:px-8 pb-12 md:pt-0 max-w-4xl">
        <div className="space-y-8">
          {projects.map((project) => (
            <div
              key={project.id}
              className={`${project.color} rounded-3xl p-8 shadow-lg`}
            >
              <h2 className="text-3xl font-bold text-gray-700 mb-6">{project.title}</h2>
              
              <div className="h-32 overflow-y-auto mb-6 pr-1 custom-scrollbar">
                <p className="text-lg text-gray-700 font-medium pr-2">
                  {project.description}
                </p>
              </div>
              
              {project.link.includes('localhost') ? (
                <button
                  className="inline-block bg-gray-600 text-white px-8 py-3 rounded-full font-medium opacity-75 cursor-not-allowed"
                  disabled
                >
                  COMING SOON
                </button>
              ) : (
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-gray-600 text-white px-8 py-3 rounded-full font-medium hover:bg-gray-700 transition-colors"
                >
                  TRY OUT
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
      
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.1);
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.2);
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(0, 0, 0, 0.3);
        }
        .custom-scrollbar {
          scrollbar-width: thin;
          scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.1);
        }
      `}</style>
    </div>
  );
};

export default Projects;